










































// @ts-nocheck
import { Component, Vue, Prop } from 'vue-property-decorator'
import { mutateSnackbar } from '@/store/snackbar'
import { Auth } from 'aws-amplify'
import { mutateTenant } from '@/store/tenant'


@Component<LoginView>({
  // @ts-ignore
  metaInfo: {
    title: `Login`
  }
})

export default class LoginView extends Vue {
  username = ``
  password = ``
  showPassword = false
  loading = false
  user
  confirmationCode = ``

  async confirmSignIn(event: Event) {
    event.preventDefault();
    this.loading = true
    try {
      await Auth.sendCustomChallengeAnswer(this.user, this.confirmationCode)
      await this.postSignIn();
    } catch (err) {
      console.error(err)
      let errorMessage = this.$t('general.unexpectedError')
      mutateSnackbar(
        { text: String(errorMessage), color: `error`, top: true },
        this.$apollo
      )
    }
    setTimeout(() => {
      this.loading = false
    }, 250)
  }

  async postSignIn() {
      const tenant = this.user.signInUserSession.accessToken.payload['cognito:groups'].find(i => i.startsWith("tenant-"))
      if (tenant) {
        const tenantName = tenant.split("-")[1]
        await mutateTenant(
          {
            tenant: {
              id: tenant,
              name: {
                de: `${tenantName.charAt(0).toUpperCase()}${tenantName.slice(1)}`
              },
              __typename: 'Tenant'
            }
          },
          this.$apollo
        )
      }
      mutateSnackbar(
        { text: String(this.$t(`general.welcome`)), color: `success` },
        this.$apollo
      )
      this.$router.push({ name: 'dashboard' })
  }

  async login(event: Event) {
    event.preventDefault()
    if (!this.username || !this.password) return
    this.loading = true
    try {
      this.user = await Auth.signIn(this.username, this.password)
      if (this.user.challengeName === "CUSTOM_CHALLENGE") {
        this.loading = false
        return;
      }
      await this.postSignIn();
    } catch (err) {
      console.log(err)
      let errorMessage = this.$t('general.unexpectedError')
      if (err.message === 'Incorrect username or password.') {
        errorMessage = this.$t('login.usernameError')
      }
      mutateSnackbar(
        { text: String(errorMessage), color: `error`, top: true },
        this.$apollo
      )
      setTimeout(() => {
        this.loading = false
      }, 250)
    }
  }
}
